import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_CONNECTED_CUSTOMERS, fetchConnectedCustomersFailure, fetchConnectedCustomersRequested, fetchConnectedCustomersSuccess } from "../actions/connected-customers-action-types";
import httpClient from "./http-client";

export function* fetchConnectedCustomerHandler() {
  yield put(fetchConnectedCustomersRequested());
  const agent = yield select((state) => state?.user?.user?.identifier);
  const request = {
    method: "GET",
    params: { userId: agent },
    url: "/api/v1/agent/connected-customer",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchConnectedCustomersFailure(data));
  } else {
    yield put(fetchConnectedCustomersSuccess(data.details));
  }
}

function* ConnectedCustomers() {
  yield all([
    takeLatest(FETCH_CONNECTED_CUSTOMERS, fetchConnectedCustomerHandler),
  ]);
}

export default ConnectedCustomers;
